import VehicleVariantContainer from "./VehicleVariantContainer";
import VehicleVariantStore from "./VehicleVariantStore";


export default VehicleVariantStore(VehicleVariantContainer);